export default __webpack_public_path__ + "static/media/hero-graphic1.8d55d718.png";